import { render } from "./resetpassword.vue?vue&type=template&id=ab5e88d8&scoped=true"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"

import "./resetpassword.vue?vue&type=style&index=0&id=ab5e88d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5e88d8"]])

export default __exports__